import React from "react";
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { setsnplmodal } from "../../redux/formslice";
import { NavLink } from "react-router-dom";

const Snplmodal = ({ productcost }) => {
    const dispatch = useDispatch();
    const snplmodal = useSelector((state) => state.formslice.snplmodal);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const close = () => {
        dispatch(setsnplmodal(false));
    };

    return (
        <div>
            <Modal show={snplmodal} centered>
                <div className="snplmodal">
                    <div className='modalclose d-flex paymentoptionsnpl pe-2 pt-2 '>
                        <div className="paymentoption-title">
                            <div className="paytitle">Payment options</div>
                        </div>
                        <div>
                            <IoClose size={20} className="cursor-pointer" onClick={close} />
                        </div>
                    </div>

                    <div className="monthlytitle">Monthly</div>

                    <div className="snpltrack">
                        <div className="subscription-card">
                            {Array.from({ length: currentcountry?.emi_months || 0 }).map((_, index) => (
                                <div className={`item ${index === 0 ? 'activeback today' : ''}`} key={index}>
                                    <div className={`indicator ${index === 0 ? 'activeindicator' : ''}`}></div>
                                    <div className={`label ${index === 0 ? 'activetitle' : ''}`}>
                                        {index === 0
                                            ? 'Today'
                                            : moment().add(index, 'months').format("dddd, Do MMMM YYYY")}
                                    </div>
                                    <div className={`price ${index === 0 ? 'activetitle' : ''}`}>
                                        {currentcountry.currency} {productcost}
                                    </div>
                                </div>
                            ))}
                            <div className="track-line"></div>
                        </div>

                        <NavLink to="/tabbyplan" className="activeformsubmitbutton textdecoration-none">
                            Learn more
                        </NavLink>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Snplmodal;
